
export const ENABLE_OVERRIDE =
    (process.env.REACT_APP_ENABLE_OVERRIDE || '').toLowerCase() === 'true';
